import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { walletExpirationSettingsApi } from 'services/apiDigitalTicket/walletExpirationSettings';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';
import * as WalletExpirationSettingsActions from './actions';

// Types
import { WalletExpirationSettingsTypes } from './types';

function* get({
  payload,
}: ReturnType<
  typeof WalletExpirationSettingsActions.getWalletExpirationSettingsRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(walletExpirationSettingsApi.get, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        WalletExpirationSettingsActions.getWalletExpirationSettingsSuccess({
          walletExpirationSettingsData: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error(
      'walletExpirationSettings - getWalletExpirationSettings - error',
      error,
    );

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(WalletExpirationSettingsActions.getWalletExpirationSettingsFailure());
    yield put(DialogsActions.setClose());
  }
}

function* update({
  payload,
}: ReturnType<
  typeof WalletExpirationSettingsActions.updateWalletExpirationSettingsRequest
>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Atualizando dados' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(walletExpirationSettingsApi.update, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        WalletExpirationSettingsActions.updateWalletExpirationSettingsSuccess({
          walletExpirationSettingsData: response.data,
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error(
      'walletExpirationSettings - updateWalletExpirationSettings - error',
      error,
    );

    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );

    yield put(
      WalletExpirationSettingsActions.updateWalletExpirationSettingsFailure(),
    );
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const walletExpirationSettingsSagas = [
  takeLatest(
    WalletExpirationSettingsTypes.GET_WALLET_EXPIRATION_SETTINGS_REQUEST,
    get,
  ),
  takeLatest(
    WalletExpirationSettingsTypes.UPDATE_WALLET_EXPIRATION_SETTINGS_REQUEST,
    update,
  ),
];
